import { Component } from '@angular/core';
import { ProcessAutoService } from 'src/app/core/services/processAuto.service';
import {
  ProcessItem,
  ProcessItemFilter,
  ProcessStructure,
} from 'src/app/core/models/processAuto.model';
import { error } from 'console';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/persons.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CommandSelect,
  CommandStatusEnum,
  CommandinfoType,
  Timeout,
} from 'src/app/core/models/commands.model';
import { CommandsService } from 'src/app/core/services/command.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-process-auto',
  templateUrl: './process-auto.component.html',
  styleUrls: ['./process-auto.component.scss'],
})
export class ProcessAutoComponent {
  constructor(
    private processAutoService: ProcessAutoService,
    private authService: AuthService,
    private modalService: NgbModal,
    public commandsService: CommandsService,
    public toastService: ToastService,
    private sanitizer: DomSanitizer
  ) {
    this.user = this.authService.currentUserValue;
    this.processStructuresForm = new ProcessStructure().toFromGroup();
    this.processStructuresForm.updateValueAndValidity();
  }
  user: User;
  circularProgressiveWait: boolean = false;
  modalFinished: boolean = false;
  filters: any[] = [];

  processStructuresFormName: string = '';
  processStructuresForm: FormGroup;
  isProcessStructuresFormEdit: boolean = false;
  items: any[] = [];

  processStructures: [ProcessStructure[]] = [[]];
  processStructuresFormLst: ProcessStructure[] = [];
  processItems: [ProcessItem[], string[]] = [[], []];
  processItemsFilter: ProcessItemFilter = new ProcessItemFilter();
  processItemsAux: ProcessItem[] = [];
  processAutoItemsBySerial: string | undefined = undefined;

  wizardState: number = 0;
  isConfigureDialogProcess: boolean = false;

  dialog: any;
  commandName: any = {};
  commandInfoType: CommandinfoType[] = [];
  commandStatusEnum = CommandStatusEnum;
  timeOutKeys: any = Object.values(Timeout).slice(
    0,
    Object.keys(Timeout).length / 2
  );

  public timeOutValues: any = Object.values(Timeout).slice(
    Object.keys(Timeout).length / 2,
    Object.keys(Timeout).length
  );
  public commandSelect: CommandSelect = {
    id: -1,
    comandoId: -1,
    nome: 'Selecione um comando',
    dispositivoModeloId: -1,
    dispositivoModelo: '',
    observacaoHTML: '',
    exemplo: '',
    valor: false,
    canalEnvio: '',
    param: '',
    seriais: '',
    timeout: '0',
    ambiente: '1',
    paramAux: '',
  };

  ngOnInit(): void {
    this.items = [
      { label: 'Etapa 1' },
      { label: 'Etapa 2' },
      { label: 'Etapa 3' },
    ];
    this.getCommandType();
    this.circularProgressiveWait = true;
    this.processAutoService.getProcessStructure().subscribe({
      next: (response: any[]) => {
        let groups: any[] = [];
        if (response.length > 0) {
          response.forEach((item: ProcessStructure) => {
            const idx = groups.findIndex((element) => element == item.group);
            if (idx > -1) {
              this.processStructures[idx].push(item);
            } else {
              if (groups.length == 0) {
                this.processStructures[0].push(item);
              } else {
                this.processStructures.push([item]);
              }
              groups.push(item.group);
            }
          });
        }
        this.circularProgressiveWait = false;
      },
      error: (error: any) => {
        console.log(error);
        this.circularProgressiveWait = false;
      },
    });
  }
  getProcessAutoItemsBySerial() {
    if (this.processAutoItemsBySerial) {
      this.processItems[0] = [];
      this.processItems[1] = [];
      this.circularProgressiveWait = true;
      let seriais = this.processAutoItemsBySerial.split(';');
      let seriaisAux: string[] = [];
      this.processAutoService.getProcessItemsBySerial(seriais).subscribe({
        next: (response: any) => {
          this.processItems[0] = response;
          this.processItems[0].forEach((item: ProcessItem) => {
            if (!seriaisAux.includes(item.serial)) {
              seriaisAux.push(item.serial);
            }
          });
          seriais.forEach((serial: string) => {
            if (
              !seriaisAux.includes(serial) &&
              !this.processItems[1].includes(serial)
            ) {
              this.processItems[1].push(serial);
            }
          });
          this.processItemsAux = this.processItems[0];
          this.circularProgressiveWait = false;
        },
        error: (error: any) => {
          this.circularProgressiveWait = false;
        },
      });
    }
  }

  includeAllInGroup(group: any) {
    this.circularProgressiveWait = true;
    this.modalFinished = false;
    this.processAutoService
      .includeInGroup(this.processItems[1].join(';'), group, this.user.userId)
      .subscribe({
        complete: () => {
          this.getProcessAutoItemsBySerial();
          this.modalFinished = true;
        },
        error: (error: any) => {
          window.alert('erro include All');

          this.circularProgressiveWait = false;
        },
      });
  }
  resetAttempts() {
    this.modalFinished = false;
    this.circularProgressiveWait = true;
    let seriais: String[] = [];
    this.processItemsAux.forEach((item: ProcessItem) => {
      let serialGroup = `${item.serial}|${item.processStructureGroup}`;
      if (!seriais.includes(serialGroup)) seriais.push(serialGroup);
    });

    if (seriais.length > 0) {
      this.processAutoService
        .resetAttempts(seriais.join(';'), this.user.userId)
        .subscribe({
          complete: () => {
            this.getProcessAutoItemsBySerial();
            this.modalFinished = true;
          },
          error: (error: any) => {
            window.alert(error);
            this.circularProgressiveWait = false;
          },
        });
    }
  }
  resetProcessItems(currentStep: any) {
    this.modalFinished = false;
    this.circularProgressiveWait = true;
    let seriais: String[] = [];
    this.processItemsAux.forEach((item: ProcessItem) => {
      let serialGroup = `${item.serial}|${item.processStructureGroup}`;
      if (!seriais.includes(serialGroup)) seriais.push(serialGroup);
    });
    if (currentStep) {
      currentStep = Number(currentStep);
    } else {
      currentStep = -1;
    }
    if (seriais.length > 0) {
      this.processAutoService
        .resetProcessItem(seriais.join(';'), currentStep, this.user.userId)
        .subscribe({
          complete: () => {
            this.getProcessAutoItemsBySerial();
            this.modalFinished = true;
          },
          error: (error: any) => {
            window.alert(error);
            this.circularProgressiveWait = false;
          },
        });
    }
  }
  removeDuplicatedSameProcessGroup() {
    this.modalFinished = false;
    this.circularProgressiveWait = true;
    let ids: String[] = [];
    let seriais: String[] = [];
    this.processItemsAux.forEach((item: ProcessItem) => {
      let serialGroup = `${item.serial}|${item.processStructureGroup}`;
      if (!seriais.includes(serialGroup)) {
        seriais.push(serialGroup);
      } else {
        ids.push(String(item.id));
      }
    });
    if (ids.length > 0) {
      this.processAutoService
        .removeDuplicatedSameProcessGroup(ids.join(';'), this.user.userId)
        .subscribe({
          complete: () => {
            this.getProcessAutoItemsBySerial();
            this.modalFinished = true;
          },
          error: (error: any) => {
            window.alert(error);
            this.circularProgressiveWait = false;
          },
        });
    }
  }

  filterProcessItems() {
    this.processItemsAux = this.processItems[0];
    this.filters.forEach((filterItem: any) => {
      switch (filterItem.key) {
        case 'serial':
          let serial: string[] = filterItem.value.split(';');
          this.processItemsAux = this.processItemsAux.filter(
            (processItemFilterItem: ProcessItem) =>
              serial.includes(processItemFilterItem.serial)
          );
          break;
        default:
          break;
      }
      switch (filterItem.type) {
        case 'text':
          this.processItemsAux = this.processItemsAux.filter(
            (processItemFilterItem: ProcessItem) =>
              String(Object(processItemFilterItem)[filterItem.key])
                .toLocaleLowerCase()
                .startsWith(filterItem.value.toLocaleLowerCase())
          );
          break;
        case 'checkbox':
          this.processItemsAux = this.processItemsAux.filter(
            (processItemFilterItem: ProcessItem) =>
              String(Object(processItemFilterItem)[filterItem.key])
                .toLocaleLowerCase()
                .startsWith(filterItem.value.toLocaleLowerCase())
          );
          break;
        case 'number':
          let condition = String(filterItem.value).substring(0, 2);
          let value = Number(String(filterItem.value).substring(2));
          switch (condition) {
            case '==':
              this.processItemsAux = this.processItemsAux.filter(
                (processItemFilterItem: ProcessItem) =>
                  Number(Object(processItemFilterItem)[filterItem.key]) == value
              );
              break;
            case '>=':
              this.processItemsAux = this.processItemsAux.filter(
                (processItemFilterItem: ProcessItem) =>
                  Number(Object(processItemFilterItem)[filterItem.key]) ==
                    value ||
                  Number(Object(processItemFilterItem)[filterItem.key]) > value
              );
              break;
            case '=<':
              this.processItemsAux = this.processItemsAux.filter(
                (processItemFilterItem: ProcessItem) =>
                  Number(Object(processItemFilterItem)[filterItem.key]) ==
                    value ||
                  Number(Object(processItemFilterItem)[filterItem.key]) < value
              );
              break;
            case '<>':
              this.processItemsAux = this.processItemsAux.filter(
                (processItemFilterItem: ProcessItem) =>
                  Number(Object(processItemFilterItem)[filterItem.key]) != value
              );
              break;
          }
          break;
        default:
          break;
      }
    });
  }

  getObjectType(key: any) {
    return Object(this.processItemsFilter)[key].type;
  }
  getCountProcessItemsDuplicate() {
    let seriais: string[] = [];
    let count = 0;

    this.processItemsAux.forEach((item: ProcessItem) => {
      if (!seriais.includes(item.serial)) {
        seriais.push(item.serial);
      } else {
        count++;
      }
    });
    return count;
  }
  getCountProcessItemsDuplicateSameGroup() {
    let seriais: string[] = [];
    let count = 0;

    this.processItemsAux.forEach((item: ProcessItem) => {
      let value = `${item.serial}|${item.processStructureGroup}`;
      if (!seriais.includes(value)) {
        seriais.push(value);
      } else {
        count++;
      }
    });
    return count;
  }

  addFilter(key: any, condition: any, valueAux: any) {
    let value = valueAux;
    if (condition) {
      value = `${condition}${valueAux}`;
    }

    let type = Object(this.processItemsFilter)[key].type;
    this.filters.push({ key, value, type });
  }

  removeFilter(filter: any) {
    const index = this.filters.indexOf(filter);
    if (index >= 0) {
      this.filters.splice(index, 1);
    }
  }

  getObjectKeys(item: any): string[] {
    let keys = Object.keys(item);
    return keys;
  }
  getValueObject(item: any, key: string) {
    return Object(item)[key];
  }

  openModal(centerDataModal: any) {
    this.dialog = this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
      scrollable: true,
    });
  }
  startConfigureDialogProcess() {
    this.isConfigureDialogProcess = true;
    this.processStructuresFormLst = [];
    this.isProcessStructuresFormEdit = false;
    this.wizardState = 0;
    let processNew = new ProcessStructure();
    processNew.step = 1;
    this.processStructuresForm = processNew.toFromGroup();
    this.processStructuresFormLst.push(processNew);
  }
  changeStep(step: any) {
    if (this.processStructuresFormLst.length != 1) {
      if (this.processStructuresFormLst[step].stepDidConfig) {
        this.isProcessStructuresFormEdit = true;
      } else {
        this.isProcessStructuresFormEdit = false;
      }
      this.wizardState = step;
      let processStructureStep = this.processStructuresFormLst[step];
      this.processStructuresForm = processStructureStep.toFromGroup();
      if (processStructureStep.isSendCommand) {
        let aux = {
          $ngOptionLabel: new String(processStructureStep.commandTypeId),
        };
        this.filterCommand(aux, true);
      }
    }
  }

  nextStep() {
    if (this.wizardState < this.items.length - 1) {
      this.wizardState++;
      this.processStructuresForm =
        this.processStructuresFormLst[this.wizardState].toFromGroup();
      let processStructureStep =
        this.processStructuresFormLst[this.wizardState];
      if (processStructureStep.stepDidConfig) {
        this.isProcessStructuresFormEdit = true;
      }
      if (processStructureStep.isSendCommand) {
        let aux = {
          $ngOptionLabel: new String(processStructureStep.commandTypeId),
        };
        this.filterCommand(aux, true);
      }
    }
  }

  checkLastProcessStructureStep(item: string, step: number) {
    if (
      this.processStructuresFormLst.length > 1 &&
      this.processStructuresFormLst.length > step
    ) {
      let lastStep = this.processStructuresFormLst[step - 1];
      if (lastStep != undefined) {
        switch (item) {
          case 'responseCommand':
            if (lastStep.analyticKeepRequestCommandIdAfterCheck) {
              return true;
            }
            break;
          default:
            break;
        }
      }
    }
    return false;
  }

  editProcessStructorLocal(step: number) {
    this.processStructuresFormLst[step].fromGroup(this.processStructuresForm);
    try {
      if (
        this.processStructuresFormLst[step]
          .analyticKeepRequestCommandIdAfterCheck
      ) {
        this.processStructuresFormLst[step + 1].isAnalyticResponseCommand =
          true;
      } else {
        this.processStructuresFormLst[step + 1].isAnalyticResponseCommand =
          false;
      }
    } catch (error) {
      console.log('');
    }
  }

  includeNewProcessStructureLocal() {
    let lastIndex = this.processStructuresFormLst.length - 1;
    this.processStructuresFormLst[lastIndex].fromGroup(
      this.processStructuresForm
    );
    this.processStructuresFormLst[lastIndex].stepDidConfig = true;
    this.processStructuresFormLst[lastIndex].step = lastIndex + 1;

    this.processStructuresFormLst.push(new ProcessStructure());

    let len = this.processStructuresFormLst.length - 1;

    if (lastIndex > 0) {
      this.processStructuresFormLst[len].name =
        this.processStructuresFormLst[lastIndex].name;
    }

    let newProcessStructure = new ProcessStructure();
    if (
      this.processStructuresFormLst[lastIndex]
        .analyticKeepRequestCommandIdAfterCheck
    ) {
      newProcessStructure.isAnalyticResponseCommand = true;
    }
    newProcessStructure.step = len + 1;

    this.processStructuresForm = newProcessStructure.toFromGroup();
    this.wizardState = len;
    this.processStructuresForm.updateValueAndValidity();
    this.isProcessStructuresFormEdit = false;
  }

  hasErrorNewProcessStructure() {
    for (let index = 0; index < this.processStructuresFormLst.length; index++) {
      const element = this.processStructuresFormLst[index];
      if (element.stepDidConfig) {
        let aux = element.toFromGroup();
        if (aux.hasError('error')) {
          return true;
        }
      }
    }
    return false;
  }
  saveNewProcessStructure() {
    this.processAutoService
      .createProcess(this.processStructuresFormLst)
      .subscribe({
        complete: () => {
          this.toastService.show('Sucesso ao criar processos', {
            classname: 'bg-success text-center text-white',
            delay: 10000,
          });
          this.processStructuresFormLst = [];
          this.processStructuresFormName = '';
          this.isProcessStructuresFormEdit = false;
          this.processStructuresForm.reset();
          this.dialog.dismissAll();
        },
        error: (error) => {
          this.toastService.show('Erro ao pesquisar - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        },
      });
  }

  getCommandType() {
    this.commandsService.getCommandsInfoType().subscribe(
      (response: any) => {
        if (response != null) {
          this.commandName = {};

          response.forEach((item: CommandinfoType) => {
            let index = this.commandInfoType.findIndex((item2) => {
              return item2.comandoId == item.comandoId;
            });

            if (index == -1) {
              this.commandName[item.comandoId.toString()] = item.nome;
              if (item.observacaoHTML != null && item.observacaoHTML != '') {
                item.observacaoHTML = `<p>${
                  item.dispositivoModelo != undefined &&
                  item.dispositivoModelo != null
                    ? item.dispositivoModelo + ' → '
                    : ''
                }${item.observacaoHTML}</p>`;
              }

              this.commandInfoType.push(item);
            } else {
              if (item.observacaoHTML != null && item.observacaoHTML != '') {
                let aux =
                  this.commandInfoType[index].observacaoHTML.split(' → ');
                if (
                  aux[aux.length - 1].substring(
                    0,
                    aux[aux.length - 1].length - 4
                  ) == item.observacaoHTML
                ) {
                  if (
                    this.commandInfoType[index].observacaoHTML.substring(
                      0,
                      3
                    ) == '<p>'
                  ) {
                    this.commandInfoType[index].observacaoHTML =
                      this.commandInfoType[index].observacaoHTML.substring(
                        3,
                        this.commandInfoType[index].observacaoHTML.length
                      );
                  }
                  this.commandInfoType[
                    index
                  ].observacaoHTML = `<p>${item.dispositivoModelo}, ${this.commandInfoType[index].observacaoHTML}`;
                } else {
                  this.commandInfoType[index].observacaoHTML = `${
                    this.commandInfoType[index].observacaoHTML
                  }<p>${
                    item.dispositivoModelo != undefined &&
                    item.dispositivoModelo != null
                      ? item.dispositivoModelo + ' → '
                      : ''
                  }${item.observacaoHTML}</p>`;
                }
              }
            }
          });
        }
      },

      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao pesquisar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  filterCommand(command: any, byId: boolean = false) {
    var commandAux: string = '';
    try {
      var commandAux: string = command['$ngOptionLabel'].trim();
    } catch (error) {}
    var commandoSelectAux = this.commandInfoType.filter((item) => {
      if (byId) {
        return item.comandoId == Number.parseInt(commandAux);
      }
      return item.nome == commandAux;
    });

    this.commandSelect.comandoId = -1;
    this.commandSelect.nome = commandAux;
    this.commandSelect.dispositivoModeloId;
    this.commandSelect.observacaoHTML = '';
    this.commandSelect.exemplo = '';
    this.commandSelect.valor = false;
    this.commandSelect.param = '';
    if (byId && commandoSelectAux.length > 0) {
      this.commandSelect.nome = commandoSelectAux[0].nome;
    }
    if (
      commandoSelectAux.length > 0 &&
      commandoSelectAux[0].observacaoHTML != undefined &&
      commandoSelectAux[0].observacaoHTML != null &&
      commandoSelectAux[0].observacaoHTML != ''
    ) {
      this.commandSelect.observacaoHTML =
        this.sanitizer.bypassSecurityTrustHtml(
          commandoSelectAux[0].observacaoHTML
        ) as string;
    }
    try {
      this.commandSelect.comandoId = commandoSelectAux[0].comandoId;
      this.commandSelect.valor = commandoSelectAux[0].valor ?? false;

      {
        if (
          commandoSelectAux[0].exemplo != undefined &&
          commandoSelectAux[0].exemplo != null &&
          commandoSelectAux[0].exemplo != ''
        )
          this.commandSelect.exemplo = commandoSelectAux[0].exemplo;
      }
    } catch (error) {}
    this.processStructuresForm
      .get('commandTypeId')
      ?.setValue(this.commandSelect.comandoId);
    this.processStructuresForm
      .get('hasCommandParam')
      ?.setValue(this.commandSelect.valor);

    if (!this.commandSelect.valor) {
      this.processStructuresForm.get('commandParam')?.setValue(undefined);
    }

    this.processStructuresForm.updateValueAndValidity();
  }

  isCircle(item: any): boolean {
    return (
      item.isSendCommand ||
      (!item.isSendCommand && !item.isAnalyticResponseCommand)
    );
  }

  isLosango(item: any): boolean {
    return item.isAnalyticResponseCommand;
  }

  isEnd(item:any){
    return !item.analyticPositionLogic && !item.isSendCommand;

  }

  getBackgroundColor(index: number): string {
    const item = this.processStructuresFormLst[index];
    if(this.isEnd(item)){
      return "purple"
    }
    if (this.wizardState === index) {
      return 'orange';
    } else if (item['stepDidConfig']) {
      if (item.isSendCommand) {
        return 'green';
      } else if (item.isAnalyticResponseCommand) {
        return 'blue';
      } else {
        return 'red';
      }
    } else {
      return 'gray';
    }
  }

  returnTimeOutName(timeout: number) {
    let index = this.timeOutValues.findIndex((item: any) => {
      return item == timeout / 1000;
    });

    if (index > -1) {
      return this.timeOutKeys[index];
    } else {
      return `\n${(timeout / 1000).toString()}s / ${(timeout / 1000 / 86400)
        .toPrecision()
        .toString()} dias`;
    }
  }
}
